module.exports = Promise.resolve(module.bundle.root("doR8W"))